// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Types
import { AppStateContextType } from 'contexts/types/app.contexts.type';
import {
  GetStateBuilderHandlersType,
  GetStateMethodsHandlersType,
  GetStateSuccessBuilderHandlersType,
} from './types/get-state.handlers.type';
import { GetStateSuccessType } from 'types/get-state-success.type';
// Utilities
import { navigateToCallbackUrl } from 'utils/app-callback-url.utils';
import {
  checkoutHasErrorOrIsNotLegit,
  onboardingHasBeenDeclinedByRisk,
  stateIsCheckoutLoading,
} from './utils/get-state.handlers.utils';

const manageOnErrorGetOnboardingStateEventHandler = ({
  setError,
}: Pick<GetStateBuilderHandlersType, 'setError'>): void => {
  setError(AppErrorEnumeration.STATE_FAILED);
};

const manageOnSuccessGetOnboardingStateEventHandler = ({
  callbackUrl,
  loanId,
  state,
  setCurrentState,
  setError,
}: GetStateSuccessBuilderHandlersType): void => {
  switch (true) {
    case onboardingHasBeenDeclinedByRisk(state):
      navigateToCallbackUrl({ callbackUrl, loanId });
      break;
    case checkoutHasErrorOrIsNotLegit(state):
      manageOnErrorGetOnboardingStateEventHandler({ setError });
      break;
    case stateIsCheckoutLoading(state):
      break;
    default:
      setCurrentState(state as AppStateContextType);
  }
};

const GetStateHandlers = ({
  setError,
  ...props
}: GetStateBuilderHandlersType): GetStateMethodsHandlersType => ({
  handleManageOnErrorGetOnboardingStateEvent: () =>
    manageOnErrorGetOnboardingStateEventHandler({ setError }),
  handleManageOnSuccessGetOnboardingStateEvent: (response: GetStateSuccessType) =>
    manageOnSuccessGetOnboardingStateEventHandler({ ...props, ...response, setError }),
});

export { GetStateHandlers };
